module.exports = __webpack_public_path__ + "img/portada1.a58c59d5.png";